import BadgesValueV2 from "../BadgesValueV2";
import MiniGamesBadgeRequirements from "./MiniGamesBadgeRequirements";

export default class MiniGamesBadgesValue extends BadgesValueV2 {
  public requirements: MiniGamesBadgeRequirements =
    new MiniGamesBadgeRequirements();
}
